export default "__VITE_ASSET__52c1cd05__"